import safelyParseJSON from '../../utils/safelyParseJson';
import safeStringify from '../../utils/safeStringify';

// src/app/reducers/auth.ts
const getAuthFromLocal = () =>
  safelyParseJSON(localStorage.getItem('auth') as string);

const initialState: any = getAuthFromLocal() || {
  auth: false,
  type: '',
};
const authReducer = (state = initialState, action: any): any => {
  switch (action.type) {
    case 'SET_AUTH': {
      localStorage.setItem('auth', safeStringify(action.payload));
      return action.payload;
    }
    default: {
      if (!state.auth) {
        const authState = getAuthFromLocal();
        return authState || state;
      }
      return state;
    }
  }
};

export default authReducer;
